<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('leaf.evaluation_leaves')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('leaf.evaluation_leaves')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('leaf.leaves'),
        data: 'evaluation_leaf_details',
        property: 'name',
        minWidth: 200,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        @refresh="refresh"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import i18n from 'src/i18n';
import EvaluationLeavesTable from 'src/views/Pages/Dashboard/Sigatoka/EvaluationLeaf/evaluation-leaves-table';
import EditCreate from 'src/views/Pages/Dashboard/Sigatoka/EvaluationLeaf/EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '80%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
  ],
  computed: {
    getModuleRoute() {
      return 'diseases/evaluationleafheader';
    },
    buildTableProperties() {
      return {
        tableColumns: [...EvaluationLeavesTable().tableColumns],
        model: 'evaluationleafheader',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
        addColumns: [
          {
            data: 'evaluation_leaf_details',
            label: i18n.t('leaf.leaves'),
            field: 'name',
          },
        ],
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
